import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from '@vfit/shared-icons';
import { IconSpan, Title, TitleText } from './moreOfferElement.style';
import { fonts } from '@vfit/shared/themes';
import { IMoreOfferElement } from './moreOfferElement.models';
import MoreOfferMobilePopup from '../MoreOfferMobilePopup/moreOfferMobilePopup';
import { checkWindow } from '@vfit/shared/data-access';

const MoreOfferElement = ({
  label,
  url,
  enableRedirect,
  border,
  elements,
  arrow,
}: IMoreOfferElement) => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  if (!label) return;

  const handleAction = () => {
    if (!enableRedirect) setIsOpenPopup(true);
    else if (checkWindow() && url) {
      window.location.href = url;
    }
  };

  return (
    <div
      style={{
        marginLeft: 24,
        marginRight: 24,
      }}
    >
      <Title haveBorder={border === 'border'} onClick={handleAction}>
        <TitleText
          isMenu={false}
          fontFamily={fonts.regular}
          fontWeight={400}
          fontSize={'18px'}
          lineHeight={'24px'}
          color={'#0D0D0D'}
        >
          {label}
        </TitleText>
        <IconSpan color={'#0D0D0D'} size={32}>
          {arrow === 'down' && <ChevronDown />}
          {arrow === 'right' && <ChevronRight />}
        </IconSpan>
      </Title>
      {isOpenPopup && (
        <MoreOfferMobilePopup
          elements={elements}
          titlePopup={label}
          handleCloseModal={() => setIsOpenPopup(false)}
        />
      )}
    </div>
  );
};

export default MoreOfferElement;
